import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function PainelSliders() {
  const [sliders, setSliders] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ titre: '', description: '', image: '', id_slider: null });
  const [filtro, setFiltro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 5;

  useEffect(() => {
    carregarSliders();
  }, []);

  const carregarSliders = async () => {
    try {
      const res = await axios.get('https://congolinaria.com.br/slider/slider.php');
      setSliders(res.data);
    } catch (error) {
      console.error("Erro ao carregar sliders:", error);
    }
  };

  const excluirSlider = async (id) => {
    if (window.confirm('Deseja realmente apagar este slider?')) {
      await axios.get(`https://congolinaria.com.br/slider/delete_slider.php?id=${id}`);
      carregarSliders();
    }
  };

  const editarSlider = (slider) => {
    setEditando(slider.id_slider);
    setForm({
      titre: slider.titre_slider,
      description: slider.description_slider,
      image: '',
      id_slider: slider.id_slider
    });
  };

  const salvarAlteracao = async () => {
    try {
      const url = form.id_slider ? 'https://congolinaria.com.br/slider/edit_slider.php' : 'https://congolinaria.com.br/slider/add_slider.php';
      await axios.post(url, form);
      setEditando(null);
      setForm({ titre: '', description: '', image: '', id_slider: null });
      carregarSliders();
    } catch (err) {
      console.error('Erro ao salvar alteração:', err);
    }
  };

  const handleImageChange = (e) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setForm({ ...form, image: reader.result });
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const slidersFiltrados = sliders.filter(slider =>
    slider.titre_slider.toLowerCase().includes(filtro.toLowerCase())
  );

  const inicio = (paginaAtual - 1) * itensPorPagina;
  const fim = inicio + itensPorPagina;
  const slidersPaginados = slidersFiltrados.slice(inicio, fim);
  const totalPaginas = Math.ceil(slidersFiltrados.length / itensPorPagina);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Painel de Sliders</h2>

      <div className="flex gap-4 mb-4">
        <input
          type="text"
          placeholder="Filtrar por título..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          className="border p-2 w-full"
        />
        <button
          onClick={() => {
            setEditando('novo');
            setForm({ titre: '', description: '', image: '', id_slider: null });
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Novo Slider
        </button>
      </div>

      {(editando !== null || form.id_slider !== null) && (
        <div className="space-y-2 mb-6 border p-4 rounded-lg">
          <h3 className="text-lg font-semibold">
            {editando === 'novo' ? 'Novo Slider' : 'Editar Slider'}
          </h3>
          <input
            className="border p-2 w-full"
            type="text"
            placeholder="Título"
            value={form.titre}
            onChange={(e) => setForm({ ...form, titre: e.target.value })}
          />
          <textarea
            className="border p-2 w-full"
            placeholder="Descrição"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {form.image && (
            <img src={form.image} alt="Preview" className="w-48 mt-2 rounded shadow" />
          )}
          <div className="flex gap-2 mt-2">
            <button onClick={salvarAlteracao} className="bg-green-600 text-white px-4 py-2 rounded">Salvar</button>
            <button
              onClick={() => {
                setEditando(null);
                setForm({ titre: '', description: '', image: '', id_slider: null });
              }}
              className="bg-gray-400 px-4 py-2 rounded"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      <ul className="space-y-4">
        {slidersPaginados.map(slider => (
          <li key={slider.id_slider} className="border rounded-xl p-4 shadow-md">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold">{slider.titre_slider}</h3>
                <p className="text-sm text-gray-600">{slider.description_slider}</p>
                <img src={`https://congolinaria.com.br/${slider.imagem_slider}`} alt="" className="mt-2 w-48 rounded-md" />
              </div>
              <div className="flex gap-2">
                <button onClick={() => editarSlider(slider)} className="bg-yellow-500 px-3 py-1 text-white rounded">Editar</button>
                <button onClick={() => excluirSlider(slider.id_slider)} className="bg-red-600 px-3 py-1 text-white rounded">Excluir</button>
              </div>
            </div>
          </li>
        ))}
      </ul>

      <div className="flex justify-center mt-6 gap-2">
        {Array.from({ length: totalPaginas }, (_, i) => (
          <button
            key={i}
            onClick={() => setPaginaAtual(i + 1)}
            className={`px-3 py-1 border rounded ${paginaAtual === i + 1 ? 'bg-black text-white' : ''}`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
